module.exports = __webpack_public_path__ + "img/20191129165513795.fd996723.jpg";